import { GetDeclarantUsers } from '@e-origin/contracts';

import { apiClient } from '@utils';

export const useUsersByDeclarant = (payload: GetDeclarantUsers) => {
  const result = apiClient.declarant.getDeclarantUsers.useQuery(
    ['declarant-users', payload.declarantId],
    { params: { declarantId: payload.declarantId } },
    {
      queryKey: ['declarant-users', payload.declarantId],
      enabled: !!payload.declarantId,
      placeholderData: { body: { data: [] } } as any,
    },
  );
  return { ...result, data: result.data?.body?.data ?? [] };
};
